import React from 'react';
import InvQuote from '../../accounting/invoice/InvQuote';

// This wrapper allows you to use the quote form in the trade job context
// Pass props as needed to control behavior (e.g., type, item, onSave, onCancel)
export default function TradeJobCreateQuoteView(props) {
  return <InvQuote  type={props.type}
          item={props.item}
          onSave={props.onSave}
          onCancel={props.onCancel} />;
}
